<div class="receipt-preview-container">
  <div class="receipt-preview">
    <div class="receipt-data" [innerHTML]="receiptPreview"></div>
  </div>
</div>
